var exports = {
  "o": "x7be19a29--e8e3e8--panorama",
};

module.exports = exports;
